import { helper } from '@ember/component/helper';

import { titleize } from 'rise-ui/utils/string.js';

const map = {
  instant: 'Instantaneous',
  average: 'Average',
  sum: 'Total',
  calculation: 'Calculated',
  none: '',
};

export default helper(function parameterTransformationHelper([ value ]) {
  value = (value || '') + '';
  const key = value.toLowerCase();
  return key in map ? map[key] : titleize(value);
});
